/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// Climate and weather data

/*
* C block for land cover and land use map selection
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '../block_compatibility_checks';
import { AreaService } from '@/services/area.service';
import { dataset } from '../dataset';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { areaChange } from '../helper_functions';

Blockly.Blocks['input_climate_data'] = {
    init: function () {
        let areas = AreaService.getAreas();

        let SATELLITES = [
            ['Daily Global Land Data Assimilation System', 'gldas'],
            ['Ocean Color SMI: Daily MODIS Aqua Data', 'chlorophyll'],
            ['S-5 Near Real Time Cloud Data', 'nrti_cloud'],
            ['Daily NOAA Ocean Near-Surface Air Atmospheric Properties', 'noaa_ocean'],
            ['Terra Daily Snow Cover 500m', 'snow_cover']];
        let PARAMS = [
            ['Albedo', 'Albedo_inst'],
            ['Average surface skin T', 'AvgSurfT_inst'],
            ['Pressure', 'Psurf_f_inst'],
            ['Soil Moisture 10 cm', 'SoilMoi0_10cm_inst'],
            ['Soil Temperature 10 cm', 'SoilTMP0_10cm_inst'],
            ['Air temperature', 'Tair_f_inst'],
            ['Wind speed', 'Wind_f_inst']];
        this.appendDummyInput()
            .appendField('Weather and climate data: ')
            .appendField(new Blockly.FieldDropdown(SATELLITES),
                "dropdown")
        this.appendDummyInput('param_inp')
            .appendField("Parameter:  ")
            .appendField(new Blockly.FieldDropdown(PARAMS), 'param')
        this.appendDummyInput('inp')
            .appendField("Area: ", 'area_text')
            .appendField(new Blockly.FieldDropdown(areas), "area")
        this.appendDummyInput()
            .appendField("From:     ")
            .appendField(new CustomFieldDate(dataset.setFrom(this.getFieldValue('dropdown'), 0, 0, 4),
                function (newValue) { return newValue }, 'true'), 'fd')
            .appendField('      To:    ')
            .appendField(new CustomFieldDate(dataset.getTo(this.getFieldValue('dropdown')),
                function (newValue) { return newValue }, 'true'), 'td');

        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('other_data'))
        this.setInputsInline(false);
        this.setStyle('atmosphere');
        this.setTooltip(Blockly.Msg.CLIMATE_DATA_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.previous_dataset = this.getFieldValue('dropdown');
        let previous_area = 'polygon';
        this.setOnChange(() => {
            if (this.getFieldValue('dropdown') !== this.previous_dataset) {
                this.previous_dataset = this.getFieldValue('dropdown');
                this.updateDropdowns_(this.getFieldValue('dropdown'));
            }
            if (this.getFieldValue('area') !== previous_area) {
                if (this.getFieldValue('area') == 'upload_shp') {
                    this.updateAreaParams_('add');
                } else if (previous_area == 'upload_shp') {
                    this.updateAreaParams_('remove');
                }
                previous_area = this.getFieldValue('area');
            }

        });

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "inp", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

    updateDropdowns_: function (sat) {
        this.getInput('param_inp').removeField('param');
        var param_array = {
            'gldas': [
                ['Albedo', 'Albedo_inst'],
                ['Average surface skin T', 'AvgSurfT_inst'],
                ['Pressure', 'Psurf_f_inst'],
                ['Soil Moisture 10 cm', 'SoilMoi0_10cm_inst'],
                ['Soil Temperature 10 cm', 'SoilTMP0_10cm_inst'],
                ['Air temperature', 'Tair_f_inst'],
                ['Wind speed', 'Wind_f_inst']],

            'chlorophyll': [
                ['Sea surface temperature', 'sst'],
                ['Chlorophyll a concentration', 'chlor_a'],
                ['Particulate organic carbon', 'poc']],

            'nrti_cloud': [
                ['Retrieved effective radiometric cloud fraction', 'cloud_fraction'],
                ['Retrieved atmospheric pressure at the level of top cloud', 'cloud_top_pressure'],
                ['Retrieved altitude of the cloud top', 'cloud_top_height'],
                ['Cloud base height', 'cloud_base_height']],

            'noaa_ocean': [
                ['Air\u00A0temperature at\u00A010m', 'air_temperature'],
                ['Specific\u00A0humidity at\u00A010m', 'specific_humidity'],
                ['Wind speed\u00A0at\u00A010m', 'wind_speed']],

            'snow_cover': [
                ['Snow\u00A0cover', 'NDSI_Snow_Cover']]
        }

        var dropdown = new Blockly.FieldDropdown(param_array[sat]);
        this.getInput('param_inp')
            .appendField(dropdown, 'param');
    },

    updateAreaParams_: function (param) {
        if (param == 'add') {
            this.getInput('inp').appendField(" Path: ", "path_text")
                .appendField(new Blockly.FieldTextInput("user/shp_name"), "path");
        } else {
            try {
                this.getInput('inp').removeField("path_text");
                this.getInput('inp').removeField("path");
            } catch (e) {/**/ }
        }
    }
};